import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const SplashScreen = ({ onComplete }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onComplete, 400);
    }, 1800);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="splash-screen"
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          data-testid="splash-screen"
        >
          <div className="splash-logo-container">
            {/* Ghost outline - dim version always visible */}
            <img
              src="/logo.png"
              alt=""
              className="splash-logo-ghost"
            />
            {/* Fill version - animates clip-path from bottom to top */}
            <motion.div
              style={{ 
                position: "absolute", 
                inset: 0, 
                overflow: "hidden" 
              }}
              initial={{ clipPath: "inset(100% 0 0 0)" }}
              animate={{ clipPath: "inset(0% 0 0 0)" }}
              transition={{ 
                duration: 1, 
                ease: [0.25, 0.46, 0.45, 0.94],
                delay: 0.3 
              }}
            >
              <img
                src="/logo.png"
                alt="Uproot Innovation"
                className="splash-logo-fill"
              />
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
